import React, { useCallback, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { PrimaryLayout } from '../Layout';

function PrimaryTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const isSaved = props?.formFields?.ROWID && props.formFields.ROWID !== "00000000-0000-0000-0000-000000000000";

    const loadLookupClient = useCallback((name, dataSource, valueExpr = 'id', displayExpr = 'text') => {
        if (!props.formRefs?.current?.[name]) return;
        const ref = props.formRefs.current[name];
        if (!ref?.instance) return;

        ref.instance().option('dataSource', dataSource);
        ref.instance().option('valueExpr', valueExpr);
        ref.instance().option('displayExpr', displayExpr);

        const currentValue = props.formFields?.[name];
        if (currentValue !== undefined) {
            ref.instance().option('value', currentValue);
        }
    }, [props.formRefs, props.formFields]);

    const finalLayout = useMemo(() => {
        // Make Record # read-only once the record has been saved
        return PrimaryLayout;
    }, [isSaved]);

    const handlePrimaryFormLoad = useCallback(() => {
        const statusOptions = [
            { id: 'A', text: 'Active' },
            { id: 'I', text: 'Inactive' }
        ];

        // Use setTimeout to ensure formRefs are available after FormField renders
        setTimeout(() => {
            loadLookupClient("STATUS", statusOptions);
        }, 100);
    }, [loadLookupClient]);

    // Load Status dropdown when formRefs become available
    useEffect(() => {
        const statusOptions = [
            { id: 'A', text: 'Active' },
            { id: 'I', text: 'Inactive' }
        ];

        loadLookupClient("STATUS", statusOptions);
    }, [loadLookupClient, props.formFields?.STATUS]);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='8E9F0A1B-EC3C-4D47-A74E-F1D2B3C4D5E6'
                layoutName='WMItemKitCodePrimaryForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handlePrimaryFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(PrimaryTab);

